var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { Divider } from '@material-ui/core';
import { mdiDotsVertical, mdiBookshelf, mdiCalendarClock, mdiHeart, mdiHeartOutline, mdiPencil, mdiProgressClose } from '@mdi/js';
import Icon from '@mdi/react';
import { usePopover } from '../../hooks/usePopover';
import { IconSize } from '../../lib';
import { TooltippedIconButton } from '../Buttons';
import { StyledMenu, StyledListItem } from './index.styles';
import { LearningModeMenu } from './LearningModeMenu';
import { ShareMenu } from './ShareMenu';
export const MoreSkillActionsMenu = (_a) => {
    var { onAddToSchedule, onChangeLearningMode, disabledModes, mode, onEdit, onResetProgress, onAddToBookshelf, onFavorite, favorited } = _a, shareMenuProps = __rest(_a, ["onAddToSchedule", "onChangeLearningMode", "disabledModes", "mode", "onEdit", "onResetProgress", "onAddToBookshelf", "onFavorite", "favorited"]);
    const showDivider = useMemo(() => !!(onChangeLearningMode || onResetProgress || onEdit), [
        onChangeLearningMode,
        onResetProgress,
        onEdit
    ]);
    const { open, anchorEl, handlePopoverClick, handlePopoverClose } = usePopover();
    return (React.createElement(React.Fragment, null,
        React.createElement(TooltippedIconButton, { icon: React.createElement(Icon, { size: IconSize.Medium, path: mdiDotsVertical }), title: "More actions", "aria-label": "More actions", onClick: handlePopoverClick }),
        React.createElement(StyledMenu, { getContentAnchorEl: null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: {
                vertical: 'bottom',
                horizontal: 'right'
            }, anchorEl: anchorEl, open: open, onClose: handlePopoverClose, onClick: (e) => {
                e.stopPropagation();
                handlePopoverClose();
            } },
            React.createElement(StyledListItem, { button: true, onClick: onAddToSchedule, disabled: !onAddToSchedule },
                React.createElement(Icon, { path: mdiCalendarClock }),
                " Learn later"),
            React.createElement(StyledListItem, { button: true, onClick: onAddToBookshelf, disabled: !onAddToBookshelf },
                React.createElement(Icon, { path: mdiBookshelf }),
                " Add to bookshelf"),
            React.createElement(StyledListItem, { button: true, onClick: onFavorite, disabled: !onFavorite },
                React.createElement(Icon, { path: favorited ? mdiHeart : mdiHeartOutline }),
                ' ',
                `${favorited ? 'Remove from' : 'Add to'} favorites`),
            React.createElement(ShareMenu, Object.assign({ variant: "listItem", closeParent: handlePopoverClose }, shareMenuProps)),
            showDivider ? React.createElement(Divider, null) : null,
            onChangeLearningMode ? (React.createElement(LearningModeMenu, { onChangeLearningMode: onChangeLearningMode, mode: mode, closeParent: handlePopoverClose, disabledModes: disabledModes })) : null,
            onResetProgress ? (React.createElement(StyledListItem, { button: true, onClick: onResetProgress },
                React.createElement(Icon, { path: mdiProgressClose }),
                " Reset progress")) : null,
            onEdit ? (React.createElement(StyledListItem, { button: true, onClick: onEdit },
                React.createElement(Icon, { path: mdiPencil }),
                " Edit")) : null)));
};
//# sourceMappingURL=MoreSkillActionsMenu.js.map